<template>
  <div 
    v-if="isOpen" 
    ref="modalRef"
    class="modal-overlay"
    role="dialog"
    aria-modal="true"
  >
    <div class="modal">
      <div class="modal__header">
        <h2 class="modal__title headline-small">{{ heading }}</h2>
        <button class="modal__close" @click="$emit('cancel')">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <line x1="18" y1="6" x2="6" y2="18"></line>
            <line x1="6" y1="6" x2="18" y2="18"></line>
          </svg>
        </button>
      </div>
      <div class="modal__content">
        <slot>
          <p class="modal__message">{{ message }}</p>
        </slot>
      </div>
      <div class="modal__actions">
        <button
          class="button button--medium button--secondary"
          @click="$emit('cancel')"
        >
          {{ cancelText }}
        </button>
        <button
          class="button button--medium button--primary"
          @click="$emit('confirm')"
        >
          {{ confirmText }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue'
import { useTabTrap } from '@/composables/useTabTrap'

export default defineComponent({
  name: 'ConfirmationModal',
  
  props: {
    isOpen: {
      type: Boolean,
      required: true
    },
    heading: {
      type: String,
      required: true
    },
    message: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: 'Bekreft'
    },
    cancelText: {
      type: String,
      default: 'Avbryt'
    }
  },

  emits: ['confirm', 'cancel'],

  setup(_, { emit }) {
    const modalRef = ref<HTMLElement | null>(null)
    useTabTrap(modalRef)

    return {
      modalRef
    }
  }
})
</script>

<style lang="scss" scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  color: $clr-text;
}

.modal {
  background: $clr-white;
  border-radius: $border-radius;
  padding: 24px;
  width: 100%;
  max-width: 500px;
  box-shadow: $box-shadow-card;

  &__header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
  }

  &__title {
    margin: 0;
    font-size: 1.25rem;
    font-weight: 600;
  }

  &__close {
    background: none;
    border: none;
    padding: 4px;
    cursor: pointer;
    color: $clr-text;
    
    &:hover {
      color: #333;
    }
  }

  &__content {
    margin-bottom: 24px;
  }

  &__message {
    margin: 0;
    padding: 0;
  }

  &__actions {
    display: flex;
    justify-content: flex-end;
    gap: 12px;
  }
}
</style>
